import { Component } from '@theme/component';

const ZOOM_TRIGGER_SELECTOR = '[data-atc-media-zoom-trigger]';
const ZOOM_ITEM_SELECTOR = '[data-atc-media-zoom-id]';

/**
 * Bridges ATC media metaobject IDs to Horizon's zoom dialog component.
 *
 * @typedef {object} Refs
 *
 * @extends {Component<Refs>}
 */
class AtcMediaGalleryZoom extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
  }

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(ZOOM_TRIGGER_SELECTOR);
    if (!(trigger instanceof HTMLElement) || !this.contains(trigger)) return;

    const mediaId = trigger.dataset.atcMediaZoomTrigger;
    if (!mediaId) return;

    const zoomDialog = this.querySelector('zoom-dialog');
    if (!isZoomDialog(zoomDialog)) return;

    const zoomItems = [...this.querySelectorAll(ZOOM_ITEM_SELECTOR)];
    const zoomIndex = zoomItems.findIndex((item) => item instanceof HTMLElement && item.dataset.atcMediaZoomId === mediaId);

    if (zoomIndex < 0) return;

    zoomDialog.open(zoomIndex, event);
  };
}

/**
 * @param {Element | null} element
 * @returns {element is Element & { open: (index: number, event: MouseEvent) => void }}
 */
const isZoomDialog = (element) => element instanceof Element && typeof element.open === 'function';

if (!customElements.get('atc-media-gallery-zoom')) {
  customElements.define('atc-media-gallery-zoom', AtcMediaGalleryZoom);
}
